<template>
	<el-dialog :close-on-click-modal='false' :visible="true" @close='close'>
		<b slot="title" class="ak-depart-table-title">Modify Password</b>
		<el-form :model='form' :rules='rules' ref='form' style='width: 60%;margin: 0 auto;' label-position="top">
			<template v-if='step == 1'>
				<el-form-item label="Original Password" label-width="120px" prop='oPassword'>
					<el-input v-model="form.oPassword" auto-complete="off" type='password'></el-input>
				</el-form-item>
			</template>
			<template v-else>
				<el-form-item label="New Password" label-width="120px" prop='Password'>
					<el-input v-model="form.Password" auto-complete="off" type='password'></el-input>
				</el-form-item>
				<br>
				
				<el-form-item label="Confirm Password" label-width="120px" prop='Password2'>
					<el-input v-model="form.Password2" auto-complete="off" type='password'></el-input>
				</el-form-item>
			</template>
		</el-form>
		<div  slot="footer" class="dialog-footer" style="display:flex;">
              <div style="flex:1;">
                <el-button @click="close">Close</el-button>
            </div>
            <div style="flex:1;">
            <el-button type="primary" @click="submit()">Submit</el-button>
            </div>
		</div>
	</el-dialog>
</template>

<script>
import { Rule } from "./rule.js";
export default {
    props:{
        close:{
            type:Function,
            required:true
        }
    },
    data () {
        let rule = new Rule();
        let that = this;
        return{
            form:{
                Password2:"",
                Password:"",
                oPassword:""
            },
            step:1,
            rules:{
                Password:[{ required: true, message: 'Please fill in a password', trigger: 'blur' },
                    {validator: rule.checkPw(), trigger: 'blur' }],
                Password2:[{ required: true, message: 'Please fill in a password again', trigger: 'blur' },
                    {validator: rule.checkPw2.apply(that), trigger: 'blur' }],
                oPassword:[{ required: true, message: 'Please fill in original password', trigger: 'blur' }]
            }
        };
    },
    mounted () {
    },
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                let form = Object.assign({},this.form);
                let methods = 'get' ;
                let url = "checkpw";

                if(this.step === 1)
                {
                    this.$http[methods](url,form,(data)=>{
                        this.$baseNotice.message(data.msg);
                        this.step = 2;
                    });
                }
                else
                {
                    let form = Object.assign({},this.form);
                    this.$http.put("modPw",
                        form,(data)=>{
                            this.$baseNotice.message(data.msg);
                            this.close();
                        });
                }

                
            });
        }	
    }
};
</script>

<style>
.ak-depart-table-title{
		font-size: 1.2rem;
		text-align: center;
		display: block;
		color: #FFF;
		font-weight:normal;
	}
</style>